/* Fixed destination; preserve attribution, avoid loops and Shopify checkout/account routes. */
(function () {
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.location.hostname === 'lifehaze.com') return;
  if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:checkouts?|account|services|challenge|gift_cards|apps|tools|admin|password|\.well-known)(?:\/|$)/i.test(window.location.pathname)) return;
  const destination = new URL('https://lifehaze.com');
  destination.pathname = window.location.pathname === '/password' ? '/' : window.location.pathname;
  destination.search = window.location.search;
  destination.hash = window.location.hash;
  for (const key of ['preview_theme_id', '_fd', 'pb']) destination.searchParams.delete(key);
  window.location.replace(destination.href);
})();
